(() => {
  const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

  const planner = document.querySelector('[data-ap-planner]');
  if (planner) {
    const form = planner.querySelector('form');
    const steps = [...form.querySelectorAll('[data-planner-step]')];
    const progress = [...form.querySelectorAll('[data-progress-step]')];
    const next = form.querySelector('[data-planner-next]');
    const back = form.querySelector('[data-planner-back]');
    const result = planner.querySelector('[data-planner-result]');
    const models = JSON.parse(planner.querySelector('[data-planner-models]').textContent);
    const oils = JSON.parse(planner.querySelector('[data-planner-oils]').textContent);
    const ui = JSON.parse(planner.querySelector('[data-planner-ui]').textContent);
    let activeStep = 0;

    const selected = (name) => form.querySelector(`input[name="${name}"]:checked`)?.value || '';

    const showStep = (index) => {
      activeStep = Math.max(0, Math.min(index, steps.length - 1));
      steps.forEach((step, stepIndex) => {
        step.hidden = stepIndex !== activeStep;
      });
      progress.forEach((item, itemIndex) => {
        item.classList.toggle('is-complete', itemIndex < activeStep);
        item.classList.toggle('is-current', itemIndex === activeStep);
      });
      back.hidden = activeStep === 0;
      next.textContent = activeStep === steps.length - 1 ? ui.seePlan : ui.continue;
      steps[activeStep].querySelector('legend')?.focus({ preventScroll: true });
    };

    const modelForAnswers = () => {
      const placement = selected('placement');
      const zone = selected('zone');
      const controls = selected('controls');
      if (placement === 'hvac' || zone === 'connected') return models.hvac;
      if (placement === 'tabletop' || zone === 'large' || controls === 'app') return models.tower;
      return models.plugin;
    };

    const renderResult = () => {
      const model = modelForAnswers();
      const mood = selected('mood');
      const scentPicks = oils[mood] || oils.clean;
      const space = form.querySelector('input[name="space"]:checked + span strong')?.textContent || ui.fallbackBusiness;
      const zone = form.querySelector('input[name="zone"]:checked + span strong')?.textContent || ui.fallbackZone;
      result.querySelector('[data-result-title]').textContent = model.name;
      result.querySelector('[data-result-price]').textContent = model.price;
      const selectionContext = ui.selectionContext
        .replace('__SPACE__', space.toLowerCase())
        .replace('__ZONE__', zone.toLowerCase());
      result.querySelector('[data-result-why]').textContent = `${model.reason} ${selectionContext}`;
      result.querySelector('[data-result-placement]').textContent = model.placement;
      result.querySelector('[data-result-controls]').textContent = model.controls;
      result.querySelector('[data-result-image]').src = model.image;
      result.querySelector('[data-result-image]').alt = model.alt;
      result.querySelector('[data-result-product]').href = model.url;
      result.querySelector('[data-result-cost]').href = `${ui.costUrl}?hardware=${encodeURIComponent(model.key)}`;
      result.querySelector('[data-result-oils]').innerHTML = scentPicks.map((oil) => `
        <article class="ap-planner-oil">
          <div><strong>${oil.name}</strong><span>${oil.notes}</span></div>
          <a href="${oil.url}">${ui.viewOil}</a>
        </article>
      `).join('');
      result.hidden = false;
      result.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      result.querySelector('[data-result-title]').focus({ preventScroll: true });
    };

    next.addEventListener('click', () => {
      const fieldset = steps[activeStep];
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (!checked) {
        fieldset.querySelector('input[type="radio"]')?.focus();
        form.querySelector('[data-planner-error]').textContent = ui.chooseOption;
        return;
      }
      form.querySelector('[data-planner-error]').textContent = '';
      if (activeStep === steps.length - 1) renderResult();
      else showStep(activeStep + 1);
    });

    back.addEventListener('click', () => showStep(activeStep - 1));
    form.addEventListener('change', () => {
      form.querySelector('[data-planner-error]').textContent = '';
    });
    showStep(0);
  }

  const calculator = document.querySelector('[data-ap-cost-calculator]');
  if (calculator) {
    const fields = {
      hardware: calculator.querySelector('[name="hardware"]'),
      units: calculator.querySelector('[name="units"]'),
      oilPrice: calculator.querySelector('[name="oil_price"]'),
      bottleSize: calculator.querySelector('[name="bottle_size"]'),
      monthlyUse: calculator.querySelector('[name="monthly_use"]'),
      cleanerPrice: calculator.querySelector('[name="cleaner_price"]'),
      cleanerUnits: calculator.querySelector('[name="cleaner_units"]')
    };

    const output = {
      firstYear: calculator.querySelector('[data-cost-first-year]'),
      hardware: calculator.querySelector('[data-cost-hardware]'),
      monthlyOil: calculator.querySelector('[data-cost-monthly-oil]'),
      annualOil: calculator.querySelector('[data-cost-annual-oil]'),
      maintenance: calculator.querySelector('[data-cost-maintenance]'),
      ongoing: calculator.querySelector('[data-cost-ongoing]'),
      cta: calculator.querySelector('[data-cost-product-link]')
    };

    const number = (field, fallback = 0) => {
      const value = Number.parseFloat(field.value);
      return Number.isFinite(value) ? Math.max(0, value) : fallback;
    };

    const calculate = () => {
      const option = fields.hardware.selectedOptions[0];
      const hardwarePrice = Number.parseFloat(option.dataset.price || '0');
      const hardwareCost = hardwarePrice * Math.max(1, Math.round(number(fields.units, 1)));
      const oilPrice = number(fields.oilPrice);
      const bottleSize = Math.max(1, number(fields.bottleSize, 30));
      const monthlyUse = number(fields.monthlyUse);
      const monthlyOil = (monthlyUse / bottleSize) * oilPrice;
      const annualOil = monthlyOil * 12;
      const maintenance = number(fields.cleanerPrice) * number(fields.cleanerUnits);
      const firstYear = hardwareCost + annualOil + maintenance;
      const ongoing = monthlyOil + (maintenance / 12);

      output.firstYear.textContent = money.format(firstYear);
      output.hardware.textContent = money.format(hardwareCost);
      output.monthlyOil.textContent = money.format(monthlyOil);
      output.annualOil.textContent = money.format(annualOil);
      output.maintenance.textContent = money.format(maintenance);
      output.ongoing.textContent = money.format(ongoing);
      output.cta.href = option.dataset.url;
      output.cta.textContent = `${calculator.dataset.costViewLabel || 'View'} ${option.dataset.shortName}`;
    };

    const query = new URLSearchParams(window.location.search);
    const requestedHardware = query.get('hardware');
    if (requestedHardware && [...fields.hardware.options].some((option) => option.value === requestedHardware)) {
      fields.hardware.value = requestedHardware;
    }
    Object.values(fields).forEach((field) => field.addEventListener('input', calculate));
    Object.values(fields).forEach((field) => field.addEventListener('change', calculate));
    calculate();
  }
})();
